/**
 * <s-try-on> — GenLook virtual try-on trigger
 * Wraps a hidden button. It stays hidden unless the GenLook app embed has
 * loaded, so shoppers never see a button that does nothing. GenLook's own
 * genlook-custom-button class then hides it on products without try-on.
 */
class STryOn extends HTMLElement {
  #button;
  #timer;

  connectedCallback() {
    this.#button = this.querySelector('button');
    if (!this.#button) return;
    this.#button.addEventListener('click', () => window.Genlook?.cabin?.open());
    let tries = 0;
    const check = () => {
      if (window.Genlook && typeof window.Genlook.ready === 'function') {
        window.Genlook.ready(() => { this.#button.hidden = false; });
        return;
      }
      tries += 1;
      if (tries < 20) this.#timer = setTimeout(check, 500);
    };
    check();
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-try-on')) customElements.define('s-try-on', STryOn);
